import React from "react";
import Headers from './Headers'
import About from './About';
import HeroSections from './HeroSections';
import Contacts from './Contacts';
import Product from './product';
import CaseStudies from './caseStudies';
import Testimonial from './testimonial';
import Clients from './clients';


const HomePage = () => {
    return (
        <div>
            <Headers/>
            <HeroSections />
            <Product />
            <CaseStudies />
            <Testimonial />
            <Clients />
            <About />
            <Contacts />
        </div>
    )
};
export default HomePage;